function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Klientska-zona",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Dlznik-Dashboard-1_0_0",
  transform: "translate(-870.000000, -1190.000000)",
  stroke: "#F7931E",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(111.000000, 370.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(0.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(647.000000, 779.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(104.000000, 10.000000) scale(-1, 1) translate(-104.000000, -10.000000) translate(83.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "
}, /*#__PURE__*/React.createElement("g", {
  id: "Right",
  transform: "translate(10.000000, 10.000000) rotate(-90.000000) translate(-10.000000, -10.000000) translate(6.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "-2.84217094e-14 0 4 4 8 0"
})))))))));

var SvgRightArrow = function SvgRightArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "10px",
    viewBox: "0 0 6 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-arrow.8e8438b6.svg";
export { ForwardRef as ReactComponent };